import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { TournamentCategory } from '../shared/tournament-category';

@Component({
  selector: 'app-set-end-player-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule],
  templateUrl: './set-end-player-component.html',
  styleUrl: './set-end-player-component.scss'
})
export class SetEndPlayerComponent {
  private dialogRef = inject(MatDialogRef<SetEndPlayerComponent>);
  private fb = inject(FormBuilder);
  private data = inject(MAT_DIALOG_DATA);

  private openSquashService = inject(OpenSquashService);

  form: FormGroup = this.fb.group({
    playerId: [''],
  });
  category: TournamentCategory | null = null;
  stage: any;
  match: any;
  player: any;

  ngOnInit(): void {
    console.log('data +++++ ', this.data);
    this.stage = this.data?.stage ?? 'sin-stage';
    this.match = this.data?.match ?? 0;
    this.player = this.data?.player ?? 0;
    this.category = this.data?.category;

    
  }

  submit() {
    if (!this.form.valid) {
      return;
    }

    console.log('guardando partidos.....');
    

    let playerId = this.form.get('playerId')?.value;
    if (playerId === '') {
      playerId = null;
    }

    if (this.stage === 'quarterFinals') {
      const quarterfinals = this.category?.finals.quarterfinals;
      if (quarterfinals) {
        const matchQuarterFinal = quarterfinals[this.match];
        if (matchQuarterFinal) {
          if (this.player === 1) {
            matchQuarterFinal.player1Id = playerId;
          } else if (this.player === 2) {
            matchQuarterFinal.player2Id = playerId;
          }
        }
      }
    }

    if (this.stage === 'semiFinals') {
      const semifinals = this.category?.finals.semifinals;
      if (semifinals) {
        const matchSemiFinal = semifinals[this.match];
        if (matchSemiFinal) {
          if (this.player === 1) {
            matchSemiFinal.player1Id = playerId;
          } else if (this.player === 2) {
            matchSemiFinal.player2Id = playerId;
          }
        }
      }
      // Marcar ganador en cuartos de final
      if (playerId) {
        this.setWinnerInPreviousStage(this.category?.finals.quarterfinals, playerId);
      }
    }

    if (this.stage === 'final') {
      const final = this.category?.finals.final;
      if (final) {
        if (this.player === 1) {
          final.player1Id = playerId;
        } else if (this.player === 2) {
          final.player2Id = playerId;
        }
      }
      // Marcar ganador en semifinales
      if (playerId) {
        this.setWinnerInPreviousStage(this.category?.finals.semifinals, playerId);
      }
    }

    if (this.stage === 'champion') {
      const final = this.category?.finals.final;
      if (final) {
        final.playerWinnerId = playerId;
      }
    }

    this.openSquashService.updateCategory(this.category!).subscribe(() => {
      this.dialogRef.close(true);
    });
  }

  private setWinnerInPreviousStage(matches: any[] | undefined, playerId: string) {
    if (!matches) return;
    const match = matches.find((m: any) => m.player1Id === playerId || m.player2Id === playerId);
    if (match) {
      match.playerWinnerId = playerId;
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}
